export function getRequiredEnvVar(name: string): string {
  const value = import.meta.env[name];
  if (value === undefined) {
    throw new Error(
      `Environment variable ${name} is required but was not found.`,
    );
  }
  return value;
}
